import {EventEmitter, Output} from "@angular/core";
import {NavigationService} from "../../../../navigation/NavigationService";

declare var jquery:any;
declare var $ :any;

/**
 * Created by Benoit Valkenberg on 03-12-17.
 */
export class GarageNavbarComponent{

    @Output() sidebarButtonClicked:EventEmitter<any> = new EventEmitter<any>();

    protected isMobile:boolean;

    constructor(protected navigationService:NavigationService){

    }

    protected DetectCurrentRoute(route:string, nav:string){
        if(route.includes("garage/car")){
            this.ActivateNewCar(nav);
        }else if(route.includes("garage/occasions")){
            this.ActivateOccasions(nav);
        }else if(route.includes("garage/workshop")){
            this.ActivateWorkshop(nav);
        }else if(route.includes("garage/leasing")){
            this.ActivateLeasing(nav);
        }else {
            this.ActivateHome(nav);
        }
    }

    public sideBarButtonIsClicked(){
        this.sidebarButtonClicked.emit();
    }

    public homeClicked(nav:string){
        this.ActivateHome(nav);
        this.navigationService.Navigate('/garage/home');
        this.GoToTop();
    }

    public newCarClicked(nav:string){
        this.ActivateNewCar(nav);
        this.navigationService.Navigate('/garage/car');
        this.GoToTop();
    }

    public occasionsClicked(nav:string){
        this.ActivateOccasions(nav);
        this.navigationService.Navigate('/garage/occasions');
        this.GoToTop();
    }

    public workshopClicked(nav:string){
        this.ActivateWorkshop(nav);
        this.navigationService.Navigate('/garage/workshop');
        this.GoToTop();
    }

    public leasingClicked(nav:string){
        this.ActivateLeasing(nav);
        this.navigationService.Navigate('/garage/leasing');
        this.GoToTop();
    }

    public contactClicked(){
        $('html, body').stop().animate({scrollTop:  $("#footer").offset().top - 50}, 1000, 'swing');
    }

    private GoToTop(){
        window.scrollTo(0, 0);
    }

    private ActivateHome(nav:string){
        $("#" + nav + "-home").addClass('active');
        $("#" + nav + "-new-car").removeClass('active');
        $("#" + nav + "-occasions").removeClass('active');
        $("#" + nav + "-workshop").removeClass('active');
        $("#" + nav + "-leasing").removeClass('active');
        $("#" + nav + "-contacts").removeClass('active');
    }

    private ActivateNewCar(nav:string){
        $("#" + nav + "-home").removeClass('active');
        $("#" + nav + "-new-car").addClass('active');
        $("#" + nav + "-occasions").removeClass('active');
        $("#" + nav + "-workshop").removeClass('active');
        $("#" + nav + "-leasing").removeClass('active');
        $("#" + nav + "-contacts").removeClass('active');
    }

    private ActivateOccasions(nav:string){
        $("#" + nav + "-home").removeClass('active');
        $("#" + nav + "-new-car").removeClass('active');
        $("#" + nav + "-occasions").addClass('active');
        $("#" + nav + "-workshop").removeClass('active');
        $("#" + nav + "-leasing").removeClass('active');
        $("#" + nav + "-contacts").removeClass('active');
    }

    private ActivateWorkshop(nav:string){
        $("#" + nav + "-home").removeClass('active');
        $("#" + nav + "-new-car").removeClass('active');
        $("#" + nav + "-occasions").removeClass('active');
        $("#" + nav + "-workshop").addClass('active');
        $("#" + nav + "-leasing").removeClass('active');
        $("#" + nav + "-contacts").removeClass('active');
    }

    private ActivateLeasing(nav:string){
        $("#" + nav + "-home").removeClass('active');
        $("#" + nav + "-new-car").removeClass('active');
        $("#" + nav + "-occasions").removeClass('active');
        $("#" + nav + "-workshop").removeClass('active');
        $("#" + nav + "-leasing").addClass('active');
        $("#" + nav + "-contacts").removeClass('active');
    }


}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/navbar/navbar/navbar.ts